// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "chip-2Ea0k";
var _5 = "close-3Gr7V";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "mobile", _4 as "chip", _5 as "close" }
export default { "__esModule": _1, "tablet_only": _2, "mobile": _3, "chip": _4, "close": _5 }
